import useSnackbarStore from '@/store/snackbar';
import { Model } from 'vue-api-query';

/**
 * api:
 * This function is used to handle fetching data from the server.
 * It adds support for per-request `showSnackbar` flag to suppress global error notifications.
 *
 * @param {NitroFetchRequest} request
 * @param {NitroFetchOptions} opts
 * @returns {pending, data, error, execute}
 */
export default defineNuxtPlugin(async () => {
  const snackbar = useSnackbarStore();
  const requestHeaders: HeadersInit = new Headers();
  requestHeaders.set('Content-Type', 'application/json');

  const $api = $fetch.create({
    baseURL: useRuntimeConfig().public.apiURL,
    headers: {
      Accept: 'application/json',
    },

    onRequest({ request, options }) {
      const noAuth = getUrlParam(request, 'X-NO-AUTH');
      const accessToken = useCookie(useRuntimeConfig().public.auth?.provider?.token?.cookieName, { watch: true });

      if (accessToken.value && !noAuth) {
        options.headers = new Headers(options.headers || {});
        options.headers.set('Authorization', `Bearer ${accessToken.value}`);
      }
    },

    async onResponseError({ request, options, response }) {
      // Check if `showSnackbar` is explicitly disabled per request
      const showSnackbar = options?.context?.showSnackbar ?? true;

      let message = response._data?.message || 'An unexpected error occurred.';

      if (response._data?.message?.includes('No query results for model')) {
        message = 'No data found.';
      }

      if (showSnackbar) {
        snackbar.showSnackbar({
          text: message,
          state: false,
        });
      }
    },
  });

  Model.$http = $api;

  return {
    provide: {
      api: $api,
    },
  };
});
